




































































































import { Component, Vue } from "vue-property-decorator";

import { mdiSpotify, mdiApple } from "@mdi/js";

@Component
export default class PromoBlock extends Vue {
  spotifyLogo = mdiSpotify;
  appleLogo = mdiApple;

  currentBlock = "";
  blocks: Map<string, number> = new Map([
    ["distrokid", 10],
    ["theory-book-carter", 10],
    ["oxygen-49", 10],
    ["camtasia-training", 8],
    ["snagit", 3],
    ["theory-guide", 3],
    ["support", 5]
  ]);
  refreshId = 0;

  mounted() {
    this.selectRandomBlock();
    setInterval(() => this.selectRandomBlock(), 30000);
  }

  beforeDestry() {
    clearInterval(this.refreshId);
  }

  selectRandomBlock() {
    let weightSum = 0;
    this.blocks.forEach(value => {
      weightSum += value;
    });

    let newBlock = "";
    let runningWeightSum = 0;
    const randomWeight = Math.random() * weightSum;
    this.blocks.forEach((value, block) => {
      if (runningWeightSum <= randomWeight) {
        newBlock = block;
      }
      runningWeightSum += value;
    });

    this.currentBlock = newBlock;
  }
}
